<script>
import api from '../tools/api';
import { toast } from 'vue-sonner'
    export default {
      watch: {
        chunks: {
          handler(val) {
            if (val.length > 0) {
                   this.upload();
            }
            else{
              this.uploadProceed = false;
              this.$emit("fileUploaded", this.addedFile);
              toast.success("File uploaded");
            }
          },
          deep: true
        },
      },
      props:{
        search_field: String,
        fileType: String,
      },
        data() {
            return {
                file: null,
                apiUrl: process.env.VUE_APP_API_URL,
                chunks: [],
                uploaded: 0,
                uploadProceed: false,
                addedFile: null
            };
        },

        computed: {
            progress() {
              if(this.file){
                  return Math.floor((this.uploaded * 100) / this.file.size);
              }
              else{return 0;}

            },
            formData() {
                let formData = new FormData;

                formData.set('is_last', this.chunks.length === 1);
                formData.set('file', this.chunks[0], `${this.file.name}`);
                formData.set('file_extension_original', this.file.name.split('.').pop());
                formData.set('project', this.search_field);
                formData.set('fileType', this.fileType);
                return formData;
            },
            config() {
                return {
                    method: 'POST',
                    data: this.formData,
                    //url: this.apiUrl+'/restrict/upload_brief',
                    url: this.apiUrl+'/restrict/test_upload_startup/'+this.search_field,

                    headers: {
                        'Content-Type': 'application/octet-stream'
                    },
                    onUploadProgress: event => {
                        this.uploaded += event.loaded;
                    }
                };
            }
        },

        methods: {
            select(event) {
                this.file = event.target.files.item(0);
                this.createChunks();
                this.uploadProceed = true;
                // console.log(this.chunks);
                // this.upload();
            },
            upload() {
                api(this.config).then((r) => {
                  console.log(r);
                  this.chunks.shift();
                  // if(r.data)this.addedFile = r.data
                }).catch(error => {console.log(error);this.uploadProceed = false;toast.error("Error during upload");});
            },
            createChunks() {
                let size = 8192, chunks = Math.ceil(this.file.size / size);

                for (let i = 0; i < chunks; i++) {
                    this.chunks.push(this.file.slice(
                        i * size, Math.min(i * size + size, this.file.size), this.file.type
                    ));
                }
            }
        }
    }
</script>

<template>
    <div>
      <label for="briefUp" class="prev_step_btn briefUploader">
        <input type="file" name="briefUp" id="briefUp" @change="select" accept=""/>
        UPLOAD YOUR CANDIDATE SELECTION
      </label>
      <div class="row" v-if="uploadProceed">
        <div class="col-12 col-xl-6 ">
          <!-- <div class="progress">
            <span class="progressText">   Upload in progess. Please wait an instant ...</span>

          </div> -->
            <span class="progressText">Upload in progress. Please wait a moment.</span>
          <v-progress-linear
            v-model="progress"
            color="blue-grey"
            height="25"
          >
        </v-progress-linear>

        </div>

      </div>
    </div>
</template>

<style media="screen">

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
}
.prev_step_btn img{
  margin-right:10px;
}

.briefUploader{
  cursor:pointer;
}
.briefUploader input[type="file"]{
  display:none;
}



.progressText{
  width:100%;
  display:block;
  margin-top:10px;
  margin-bottom:10px;
  text-align: center;
}

</style>
